(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global['wowoo-advertise-request'] = factory());
})(this, function () {
  'use strict';

  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
    Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */
  function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function (resolve) {
        resolve(value);
      });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  }
  function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
          if (t[0] & 1) throw t[1];
          return t[1];
        },
        trys: [],
        ops: []
      },
      f,
      y,
      t,
      g;
    return g = {
      next: verb(0),
      "throw": verb(1),
      "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
      return this;
    }), g;
    function verb(n) {
      return function (v) {
        return step([n, v]);
      };
    }
    function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (_) try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
      if (op[0] & 5) throw op[1];
      return {
        value: op[0] ? op[1] : void 0,
        done: true
      };
    }
  }

  // @ts-nocheck
  var uri = 'https://alipay-bu-gw-prod.renliwo.com';
  var uri1 = 'https://slb-marketing-service.renliwo.com';
  var uri2 = 'https://marketing-backend-uat.renliwo.com';
  // const uri = 'https://alipay-bu-gw-uat.renliwo.com'
  var num = 0; //处理token失效重复调用的问题
  /**
   * @param params 广告位参数
   * @url url 调用路径
   * @returns
   */
  var adRequest = function adRequest(params, url) {
    if (url === void 0) {
      url = '';
    }
    return __awaiter(void 0, void 0, void 0, function () {
      var newUrl, token, newParams, newUrl, token, newParams, newUrl, token, newParams;
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
      return __generator(this, function (_l) {
        switch (_l.label) {
          case 0:
            if (!params.isOnlyH5) return [3 /*break*/, 2];
            newUrl = (url || uri) + '/marketing-backend/marketing/requestAdvertising';
            return [4 /*yield*/, (_b = (_a = window) === null || _a === void 0 ? void 0 : _a.loginModel) === null || _b === void 0 ? void 0 : _b.getToken()];
          case 1:
            token = _l.sent();
            if (!token) {
              if (newUrl.indexOf('uat') === -1) {
                newUrl = uri1 + '/marketing/advertising/getSiteMess';
              } else {
                newUrl = uri2 + '/marketing/advertising/getSiteMess';
              }
            }
            newParams = Object.assign({}, (_d = (_c = window) === null || _c === void 0 ? void 0 : _c.glowworm) === null || _d === void 0 ? void 0 : _d.baseInfo, params);
            return [2 /*return*/, _h5Request(newParams, newUrl, token)];
          case 2:
            if (!(my && my.httpRequest && typeof my.httpRequest === 'function')) return [3 /*break*/, 4];
            newUrl = (url || uri) + '/marketing-backend/marketing/requestAdvertising';
            return [4 /*yield*/, (_e = my === null || my === void 0 ? void 0 : my.loginModel) === null || _e === void 0 ? void 0 : _e.getToken()];
          case 3:
            token = _l.sent();
            if (!token) {
              if (newUrl.indexOf('uat') === -1) {
                newUrl = uri1 + '/marketing/advertising/getSiteMess';
              } else {
                newUrl = uri2 + '/marketing/advertising/getSiteMess';
              }
            }
            newParams = Object.assign({}, (_f = my === null || my === void 0 ? void 0 : my.glowworm) === null || _f === void 0 ? void 0 : _f.baseInfo, params);
            return [2 /*return*/, _aliRequest(newParams, newUrl, token)];
          case 4:
            newUrl = (url || uri) + '/marketing-backend/marketing/requestAdvertising';
            return [4 /*yield*/, (_h = (_g = window) === null || _g === void 0 ? void 0 : _g.loginModel) === null || _h === void 0 ? void 0 : _h.getToken()];
          case 5:
            token = _l.sent();
            if (!token) {
              if (newUrl.indexOf('uat') === -1) {
                newUrl = uri1 + '/marketing/advertising/getSiteMess';
              } else {
                newUrl = uri2 + '/marketing/advertising/getSiteMess';
              }
            }
            newParams = Object.assign({}, (_k = (_j = window) === null || _j === void 0 ? void 0 : _j.glowworm) === null || _k === void 0 ? void 0 : _k.baseInfo, params);
            return [2 /*return*/, _h5Request(newParams, newUrl, token)];
        }
      });
    });
  };
  var _aliRequest = function aliRequest(params, url, token) {
    return new Promise(function (resolve, reject) {
      my.httpRequest({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': "Bearer " + token,
          'permit': 'SB001'
        },
        url: url,
        method: 'POST',
        data: params,
        dataType: 'json',
        complete: function complete(res) {
          var _a;
          return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
              if (res.status === 200) {
                if (res.data.code == 200) {
                  num = 0;
                  resolve(res.data);
                } else if (res.data.code == 6002 || res.data.code == 6003) {
                  if (num < 3) {
                    (_a = my === null || my === void 0 ? void 0 : my.loginModel) === null || _a === void 0 ? void 0 : _a.baseLogin(function (res) {
                      num += 1;
                      resolve(_aliRequest(params, url, res.result.token));
                    });
                  } else {
                    resolve({
                      msg: '登录失败'
                    });
                  }
                }
              }
              return [2 /*return*/];
            });
          });
        },
        fail: function fail(err) {
          reject(err);
        }
      });
    });
  };
  var _h5Request = function h5Request(params, url, token) {
    return new Promise(function (resolve, reject) {
      var xmlhttp = new XMLHttpRequest() || new window.ActiveXObject('Microsoft.XMLHTTP');
      xmlhttp.open('POST', url, true);
      xmlhttp.setRequestHeader('Content-type', 'application/json');
      xmlhttp.setRequestHeader('permit', 'SB001');
      xmlhttp.setRequestHeader('Authorization', "Bearer " + token);
      xmlhttp.onload = function () {
        var _a, _b;
        if (xmlhttp.status == 200) {
          if (JSON.parse(xmlhttp.response).code == 200) {
            num = 0;
            resolve(JSON.parse(xmlhttp.response));
          } else if (JSON.parse(xmlhttp.response).code == 6002 || JSON.parse(xmlhttp.response).code == 6003) {
            if (num < 3) {
              (_b = (_a = window) === null || _a === void 0 ? void 0 : _a.loginModel) === null || _b === void 0 ? void 0 : _b.baseLogin(function (res) {
                num += 1;
                resolve(_h5Request(params, url, res.result.token));
              });
            } else {
              resolve({
                msg: '登录失败'
              });
            }
          }
        } else {
          reject(new Error(JSON.stringify(xmlhttp.response)));
        }
      };
      xmlhttp.onerror = function () {
        reject({
          err: 'error'
        });
      };
      xmlhttp.send(JSON.stringify(params));
    });
  };

  /*
   * @Description:
   * @Author: zhuyongqing
   * @Date: 2021-08-13 17:41:01
   * @LastEditors: zhuyongqing
   * @LastEditTime: 2021-08-13 17:53:17
   */

  return adRequest;
});